import React from 'react'

const Animation = (): JSX.Element => {
  return (
    <div className='rf-relative rf-loader rf-animate-loader rf-h-6 -rf-top-6 rf-rounded-half' />
  )
}

export default Animation
